import {Button} from '@components/ui/button'
import {HostNotReadyModal} from '@features/assignment/components/host-not-ready-modal'
import {UnresponsiveHostModal} from '@features/assignment/components/unresponsive-host-modal'
import {FreelancerNotAvailableModal} from '@features/assignment/components/freelancer-not-available-modal'
import {CannotScheduleModal} from '@features/assignment/components/cannot-schedule-modal'
import {ScheduleModal} from '@features/assignment/components/schedule-modal'
import {useTranslation} from '@/translations/i18n.tsx'
import {useState} from 'react'
import {Assignment, ServiceType} from '@features/assignment/types.ts'

export type ModalName = 'host_not_ready' | 'unresponsive_host' | 'not_available' | 'schedule' | 'cannot_schedule'
export const ScheduleButtons = ({assignment, serviceType}: {assignment: Assignment; serviceType: ServiceType}) => {
    const {t} = useTranslation()
    const [openModal, setOpenModal] = useState<ModalName | null>(null)

    return (
        <>
            <div className="flex w-full flex-col items-center gap-2 md:w-auto md:flex-row">
                <Button
                    variant="secondary"
                    onClick={() => setOpenModal('cannot_schedule')}
                    className="w-full md:w-auto"
                >
                    {t('assignment:descriptions:cannot_schedule')}
                </Button>
                <Button variant="primary" onClick={() => setOpenModal('schedule')} className="w-full md:w-auto">
                    {t('assignment:descriptions:ready_to_schedule')}
                </Button>
            </div>
            {openModal == 'host_not_ready' && (
                <HostNotReadyModal
                    assignmentId={assignment.id}
                    taskId={assignment.task.id}
                    onClose={() => setOpenModal(null)}
                />
            )}
            {openModal == 'unresponsive_host' && (
                <UnresponsiveHostModal
                    assignmentId={assignment.id}
                    onClose={() => setOpenModal(null)}
                    taskId={assignment.task.id}
                />
            )}
            {openModal == 'not_available' && (
                <FreelancerNotAvailableModal
                    serviceType={serviceType}
                    assignmentId={assignment.id}
                    taskId={assignment.task.id}
                    onClose={() => setOpenModal(null)}
                />
            )}
            {openModal == 'cannot_schedule' && (
                <CannotScheduleModal
                    setOpenModal={setOpenModal}
                    assignmentId={assignment.id}
                    taskId={assignment.task.id}
                    onClose={() => setOpenModal(null)}
                    serviceType={serviceType}
                />
            )}
            {openModal == 'schedule' && (
                <ScheduleModal assignment={assignment} serviceType={serviceType} onClose={() => setOpenModal(null)} />
            )}
        </>
    )
}
